import {
  isValidPhoneNumber,
  getCountries,
  getCountryCallingCode,
} from 'libphonenumber-js'

export const validatePhoneNumber = (phone: string, callingCode?: string) => {
  try {
    const raw = phone.trim()

    // If no calling code provided, require E.164 and validate directly
    if (!callingCode) {
      return raw.startsWith('+') && isValidPhoneNumber(raw)
    }

    const cc = callingCode.trim()

    // 1) Validate calling code existence
    const isValidCallingCode = getCountries().some(
      country => getCountryCallingCode(country) === cc,
    )
    if (!isValidCallingCode) return false

    // 2) Validate/normalize combined format
    let e164: string

    if (raw.startsWith('+')) {
      // Must match +<callingCode>...
      if (!raw.startsWith(`+${cc}`)) return false
      // Must be digits after '+'
      if (!/^\+\d+$/.test(raw)) return false
      e164 = raw
    }
    else {
      // Local number must be digits only (your UI already disallows '+')
      if (!/^\d+$/.test(raw)) return false
      e164 = `+${cc}${raw}`
    }

    // 3) Validate number in E.164
    return isValidPhoneNumber(e164)
  }
  catch {
    return false
  }
}
